<!-- <app-header-four></app-header-four> -->
<app-header-one></app-header-one>
<div class="main-banner-section height_image item-bg166">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="main-banner-content">
                    <h1>RESPONSABILITE CIVILE ENTREPRISE</h1>
                    <p>L’assurance Responsabilité Civile d’Entreprise a pour objet de vous garantir contre les dommages corporels, matériels et immatériels consécutifs causés aux tiers du fait de l’exercice de votre activité professionnelle.
                    </p>
                    <div class="btn-box">
                        <a (click)="souscrire()" class="default-btn btnO">Obtenir un devis<span></span></a>
                        <a class="optional-btn rappel" (click)="rappeler()">Me faire rappeler<span></span></a>
                    </div>
                    <!-- <div class="btn-box" *ngIf="login">
                        <a (click)="souscrire()" class="default-btn btnO">Obtenir un devis<span></span></a>
                        <a class="optional-btn rappel">Me faire rappeler<span></span></a>
                    </div> -->
                </div>
            </div>
        </div>
    </div>

    <div class="shape1"><img src="assets/img/car.png" alt="image"></div>
    <div class="shape2"><img src="assets/img/umbrella-white.png" alt="image"></div>
    <div class="shape3"><img src="assets/img/home.png" alt="image"></div>
    <div class="shape4"><img src="assets/img/heart.png" alt="image"></div>
</div>

<div class="row desc container-row justify-content-center" id="contact" #contact>
    <!-- *ngIf="login" -->
    <div class="col-12 droite" *ngIf="login">
        <form [formGroup]="simulationRceForm" class="auto">
            <aw-wizard class="stepper-container bg-whtie pb-5" #wizard [navBarLocation]="'top'" [navBarLayout]="'large-empty'" [disableNavigationBar]="false">
                <aw-wizard-step [navigationSymbol]="{ symbol: '1' }" stepTitle="Entreprise">
                    <div class="form-container">
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                                <div class="form" ngbPopover="Nom (ou Raison Sociale)" triggers="mouseenter:mouseleave">
                                    <i class="fa fa-user form__icon"></i>
                                    <div class="form__separator">
                                    </div>
                                    <input type="text" id="raisonSocial" class="form__input" autocomplete="off" placeholder=" " formControlName="raisonSocial" />
                                    <label for="raisonSocial" class="form__label">Nom (ou Raison Sociale)<span class="text-red"> *</span></label>
                                </div>
                                <div class="error min-max text-red" *ngIf="invalid && simulationRceForm.get('raisonSocial').invalid">
                                    Ce champ est obligatoire
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                                <div class="form" ngbPopover="Adresse" triggers="mouseenter:mouseleave">
                                    <!-- <i class="fa fa-user form__icon"></i> -->
                                    <i class="fa-solid fa-location-dot form__icon"></i>
                                    <div class="form__separator">
                                    </div>
                                    <input type="text" id="adresse" class="form__input" autocomplete="off" placeholder=" " formControlName="adresse" />
                                    <label for="adresse" class="form__label">Adresse<span class="text-red"> *</span></label>
                                </div>
                                <div class="error min-max text-red" *ngIf="invalid && simulationRceForm.get('adresse').invalid">
                                    Ce champ est obligatoire
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" style="margin-top:20px">
                                <div class="form" placement="left" ngbPopover="Forme juridique" triggers="mouseenter:mouseleave">
                                    <i class="fa fa-flag form__icon"></i>
                                    <div class="form__separator">
                                    </div>
                                    <select id="cars" formControlName="formeJuridique" placeholder=" " class="form__select">
                                         <option value="" disabled selected>Forme juridique</option>
                                         <option *ngFor="let formeJ of listStatutJuridique" [value]="formeJ.name">{{formeJ?.name}}</option>
                                    </select>
                                    <label for="cars" class="form__label">Forme juridique<span class="text-red"> *</span></label>
                                </div>
                                <div class="error min-max text-red" *ngIf="invalid && simulationRceForm.get('formeJuridique').invalid">
                                    Ce champ est obligatoire
                                </div>
                            </div>
                            <!-- <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                                <div class="form" placement="left" ngbPopover="Activité de l'entreprise" triggers="mouseenter:mouseleave">
                                    <i class="fa fa-flag form__icon"></i>
                                    <div class="form__separator">
                                    </div>
                                    <select id="cars" formControlName="activiteEntreprise" placeholder=" " class="form__select">
                                         <option value="" disabled selected>Activité de l'entreprise</option>
                                         <option *ngFor="let secteur of secteursAc" [value]="secteur.name">{{secteur?.name}}</option>
                                    </select>
                                    <label for="cars" class="form__label">Activité de l'entreprise<span class="text-red"> *</span></label>
                                </div>
                                <div class="error min-max text-red" *ngIf="invalid && simulationRceForm.get('activiteEntreprise').invalid">
                                    Ce champ est obligatoire
                                </div>
                            </div> -->
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" style="margin-top:-15px">
                                <div class="form" ngbPopover="Activité de l'entreprise" triggers="mouseenter:mouseleave">
                                    <label for="textarea">Activité de l'entreprise</label>
                                    <textarea placeholder="Activité de l'entreprise" class="areaStyle" name="activiteEntreprise" id="activiteEntreprise" maxlength="65525" formControlName="activiteEntreprise"></textarea>
                                </div>
                                <div class="error min-max text-red" *ngIf="invalid && simulationRceForm.get('activiteEntreprise').invalid" style="padding-top: 35px;">
                                    Ce champ est obligatoire
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" style="margin-top:35px">
                                <div class="form" ngbPopover="Date de mise en exploitation de l'entreprise" triggers="mouseenter:mouseleave">
                                    <i class="fa-solid fa-calendar-days form__icon"></i>
                                    <div class="form__separator">
                                    </div>
                                    <input type="text" id="dateExploitation" class="form__input" placeholder=" " (dateSelect)="onDateSelect($event,'dateExploitation')" ngbDatepicker #dateExploitation="ngbDatepicker" (click)="dateExploitation.toggle()" />
                                    <label for="dateExploitation" class="form__label">Date de mise en exploitation<span class="text-red"> *</span></label>
                                </div>
                                <div class="error min-max text-red" *ngIf="invalid && simulationRceForm.get('dateExploitation').invalid">
                                    Ce champ est obligatoire
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                                <div class="form" ngbPopover="Chiffre d'affaire des cinq derniers exercises" triggers="mouseenter:mouseleave">
                                    <label for="textarea">Chiffre d'affaire des cinq derniers exercises</label>
                                    <textarea placeholder="Chiffre d'affaire des cinq derniers exercises" class="areaStyle" name="chiffreAffaire" id="chiffreAffaire" maxlength="65525" formControlName="chiffreAffaire"></textarea>
                                </div>
                                <div class="error min-max text-red" *ngIf="invalid && simulationRceForm.get('chiffreAffaire').invalid" style="padding-top: 35px;">
                                    Ce champ est obligatoire
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" style="margin-top:35px">
                                <div class="form" ngbPopover="Chiffre d'affaire prévisionnel" triggers="mouseenter:mouseleave">
                                    <i class="fa-solid fa-money-bill form__icon"></i>
                                    <div class="form__separator">
                                    </div>
                                    <input type="text" mask="separator" id="chiffreAffairePreci" class="form__input" autocomplete="off" placeholder=" " formControlName="chiffreAffairePreci" />
                                    <label for="chiffreAffairePreci" class="form__label">Chiffre d'affaire prévisionnel<span class="text-red"> *</span></label>
                                </div>
                                <div class="error min-max text-red" *ngIf="invalid && simulationRceForm.get('chiffreAffairePreci').invalid">
                                    Ce champ est obligatoire
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                                <div class="form" ngbPopover="Masse salariale des cinq derniers exercises" triggers="mouseenter:mouseleave">
                                    <label for="textarea">Masse salariale des cinq derniers exercises</label>
                                    <textarea placeholder="Masse salariale des cinq derniers exercises" class="areaStyle" name="masseSalarial" id="masseSalarial" maxlength="65525" formControlName="masseSalarial"></textarea>
                                </div>
                                <div class="error min-max text-red" *ngIf="invalid && simulationRceForm.get('masseSalarial').invalid" style="padding-top: 35px;">
                                    Ce champ est obligatoire
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                                <div class="form" ngbPopover="Masse salariale prévisionnel annuel" triggers="mouseenter:mouseleave">
                                    <i class="fa-solid fa-money-bill form__icon"></i>
                                    <div class="form__separator">
                                    </div>
                                    <input type="number" min="0" id="masseSalarialPreci" class="form__input" autocomplete="off" placeholder=" " formControlName="masseSalarialPreci" />
                                    <label for="masseSalarialPreci" class="form__label">Masse salariale prévisionnel<span class="text-red"> *</span></label>
                                </div>
                                <div class="error min-max text-red" *ngIf="invalid && simulationRceForm.get('masseSalarialPreci').invalid">
                                    Ce champ est obligatoire
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                                <div class="form" ngbPopover="Nombre d'employés" triggers="mouseenter:mouseleave">
                                    <i class="fa-solid fa-users form__icon"></i>
                                    <div class="form__separator">
                                    </div>
                                    <input type="number" min="0" id="nbrPersonnel" class="form__input" autocomplete="off" placeholder=" " formControlName="nbrPersonnel" />
                                    <label for="nbrPersonnel" class="form__label">Nombre d'employés<span class="text-red"> *</span></label>
                                </div>
                                <div class="error min-max text-red" *ngIf="invalid && simulationRceForm.get('nbrPersonnel').invalid">
                                    Ce champ est obligatoire
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" style="margin-top:-15px">
                                <div class="form" ngbPopover="Principaux client" triggers="mouseenter:mouseleave">
                                    <label for="textarea">Principaux clients</label>
                                    <textarea placeholder="Principaux client" class="areaStyle" name="clientList" id="clientList" maxlength="65525" formControlName="clientList"></textarea>
                                </div>
                                <div class="error min-max text-red" *ngIf="invalid && simulationRceForm.get('clientList').invalid" style="padding-top: 35px;">
                                    Ce champ est obligatoire
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-5 c-btnWidth">
                            <button type="button" class="btn btn-warning btn-prev c-btn-prev pull-right c-roundbtn" (click)="retour()"><i
                        class="fa fa-chevron-left"></i>Retour</button>
                        </div>
                        <div class="col-5 c-btnWidth">
                            <button type="button" class="btn btn-success btn-next c-btn-next pull-left c-roundbtn" (click)="nextstep()">Suivant <i
                        class="fa fa-chevron-right"></i></button>
                        </div>
                    </div>
                </aw-wizard-step>


                <aw-wizard-step [navigationSymbol]="{ symbol: '2' }" stepTitle="Entreprise">
                    <div class="form-container" formGroupName="entreprise2">
                        <div class="row  justify-content-center">
                            <label for="details" class="form__label1 c-effectuer">Effectuez-vous des travaux de chargement et déchargement avec les véhicules appartenant à des tiers ?</label>
                            <div class="form-check form-check-inline col-2">
                                <input class="form-check-input" formControlName="travaux" type="radio" name="travaux" id="inlineRadio1" value="oui">
                                <label class="form-check-label tfes" for="inlineRadio1">OUI</label>
                            </div>
                            <div class="form-check form-check-inline col-2">
                                <input class="form-check-input" formControlName="travaux" type="radio" name="travaux" id="inlineRadio2" value="non">
                                <label class="form-check-label tfes" for="inlineRadio2">NON</label>
                            </div>
                            <div class="error min-max text-red" *ngIf="invalid && simulationRceForm.get('entreprise2').get('travaux').invalid">
                                Ce champ est obligatoire
                            </div>
                        </div>

                        <div class="row no-margin" *ngIf="simulationRceForm.get('entreprise2').get('travaux').value == 'oui'">
                            <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                                <div class="form" ngbPopover="Décrivez les appareil servant au transport ou au lavage" triggers="mouseenter:mouseleave">
                                    <textarea placeholder="Décrivez les appareil servant au transport ou au lavage" class="areaStyle" name="descriptionAppareil" id="descriptionAppareil" maxlength="65525" formControlName="descriptionAppareil"></textarea>
                                </div>
                                <div class="error min-max text-red" *ngIf="invalid && simulationRceForm.get('entreprise2').get('descriptionAppareil').invalid">
                                    Ce champ est obligatoire
                                </div>
                            </div>
                        </div>

                        <div class="row  justify-content-center">
                            <label for="details" class="form__label1 c-text2">L'entreprise est-elle locataire ou propriétaire des locaux qu'elle occupe ?</label>
                            <div class="form-check form-check-inline col-2">
                                <input class="form-check-input" formControlName="locataireOrProprietaire" type="radio" name="locataireOrProprietaire" id="inlineRadioL1" value="locataire">
                                <label class="form-check-label tfes" for="inlineRadioL1">LOCATAIRE</label>
                            </div>
                            <div class="form-check form-check-inline col-2">
                                <input class="form-check-input" formControlName="locataireOrProprietaire" type="radio" name="locataireOrProprietaire" id="inlineRadioL2" value="proprietaire">
                                <label class="form-check-label tfes" for="inlineRadioL2">PROPRIETAIRE</label>
                            </div>
                            <div class="error min-max text-red" *ngIf="invalid && simulationRceForm.get('entreprise2').get('locataireOrProprietaire').invalid">
                                Ce champ est obligatoire
                            </div>
                        </div>

                        <div class="row  justify-content-center">
                            <label for="details" class="form__label1 c-text2">L'entreprise entrepose-t-elle ou utilise-t-elle des matières dangereuses ?</label>
                            <div class="form-check form-check-inline col-2">
                                <input class="form-check-input" formControlName="entrepose" type="radio" name="entrepose" id="inlineRadioD1" value="oui">
                                <label class="form-check-label tfes" for="inlineRadioD1">OUI</label>
                            </div>
                            <div class="form-check form-check-inline col-2">
                                <input class="form-check-input" formControlName="entrepose" type="radio" name="entrepose" id="inlineRadioD1" value="non">
                                <label class="form-check-label tfes" for="inlineRadioD1">NON</label>
                            </div>
                            <div class="error min-max text-red" *ngIf="invalid && simulationRceForm.get('entreprise2').get('entrepose').invalid">
                                Ce champ est obligatoire
                            </div>
                        </div>

                        <div class="row no-margin" *ngIf="simulationRceForm.get('entreprise2').get('entrepose').value == 'oui'">
                            <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                                <div class="form" ngbPopover="Décrivez les matières" triggers="mouseenter:mouseleave">
                                    <textarea placeholder="Décrivez les matières" class="areaStyle" name="matiere" id="matiere" maxlength="65525" formControlName="matiere"></textarea>
                                </div>
                                <div class="error min-max text-red" *ngIf="invalid && simulationRceForm.get('entreprise2').get('matiere').invalid">
                                    Ce champ est obligatoire
                                </div>
                            </div>
                        </div>

                        <div class="row no-margin">
                            <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                                <div class="form" ngbPopover="Autres Déclarations" triggers="mouseenter:mouseleave">
                                    <textarea placeholder="Autres Déclarations" class="areaStyle" name="autreDeclaration" id="autreDeclaration" maxlength="65525" formControlName="autreDeclaration"></textarea>
                                </div>
                                <div class="error min-max text-red" *ngIf="invalid && simulationRceForm.get('entreprise2').get('autreDeclaration').invalid">
                                    Ce champ est obligatoire
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="row justify-content-center">
                        <div class="col-5 c-btnWidth">
                            <button type="button" class="btn btn-warning btn-prev c-btn-prev pull-right c-roundbtn" (click)="retour()" awPreviousStep><i
                        class="fa fa-chevron-left"></i> Retour</button>
                        </div>
                        <div class="col-5 c-btnWidth">
                            <button type="button" class="btn btn-success btn-next c-btn-next pull-left c-roundbtn" [disabled]="sendingRequest" (click)="nextstep()">Suivant</button>
                        </div>
                    </div>
                </aw-wizard-step>

                <aw-wizard-step [navigationSymbol]="{ symbol: '3' }" stepTitle="Pièce Jointe">
                    <div class="container">
                        <div class="row col-lg-6 col-md-12 col-xs-12 col-sm-12 c-imgRow" *ngIf="!downloadFile">
                            <div title="Cliquer pour charger la Pièce Jointe" class="image c-image bg-card" (click)="PIECE.click()">
                                <img src="{{noImage}}" alt="" class="myImg">
                                <div class="titleImage">Pièce Jointe</div>
                                <input [disabled]="loader" hidden #PIECE multiple class="use-avatar" (change)="selectOnFile($event,'PIECE','PIECE')" type="file" id="file" required accept=".doc , .DOC , .docx , .DOCX , .docm , .DOCM" />
                            </div>
                            <div class="chargement" *ngIf="loader">
                                <i class="text-center fa fa-spinner fa-pulse"></i> Chargement du fichier.....
                            </div>
                        </div>
                        <div class="row col-lg-6 col-md-12 col-xs-12 col-sm-12 c-imgRow" *ngIf="downloadFile">
                            <div title="Cliquer pour Télecharger le questionnaire" class="image c-image bg-card">
                                <a (click)="downloadModel()" href="/assets/images/Questionnaire_MRP_Abidjanaise.doc">
                                    <img src="{{downloadImage}}" alt="" class="myImg">
                                </a>
                                <div class="titleImage">Télecharger le questionnaire</div>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-5 c-btnWidth">
                            <button type="button" class="btn btn-warning btn-prev c-btn-prev pull-right c-roundbtn" awPreviousStep (click)="retour()"><i
                        class="fa fa-chevron-left"></i>Retour</button>
                        </div>
                        <div class="col-5 c-btnWidth">
                            <button type="button" class="btn btn-success btn-next c-btn-next pull-left c-roundbtn" (click)="nextstep()">Suivant <i class="fa fa-angle-double-right"></i></button>
                        </div>
                    </div>
                </aw-wizard-step>



                <aw-wizard-step [navigationSymbol]="{ symbol: '4' }" stepTitle="Récapitulatif">
                    <div class="recap-form-container">
                        <div class="mesImage row col-md-12 col-lg-12 col-sm-12 col-xs-12">
                            <div class="imgLogo col-md-6 col-lg-6 col-sm-12 col-xs-12">
                                <!-- <img src="../../../../assets/img/logo123.png" alt=""> -->
                                <img [src]="logoImage" alt="logo">
                            </div>
                            <div class="imgLogoR col-md-6 col-lg-6 col-sm-12 col-xs-12">
                                <!-- <img src="../../../../assets/img/logo.png" alt=""> -->
                            </div>
                        </div>
                        <div class="info-devis">
                            <div class="proposition">
                                <div class="pro-title">RÉCAPITULATIF</div>
                                <!-- <div class="sub-title">(Cette proposition est valable jusqu'au {{dateExpiration | date:'dd/MM/yyyy'}})
                                </div> -->
                            </div>
                            <div class="row ">
                                <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6">
                                    <div class="title-div">
                                        <span>Information Entreprise</span>
                                        <!-- <span class="fa fa-edit edit-pro" placement="top" ngbPopover="Cliquer pour modifier les infos de la maison" triggers="mouseenter:mouseleave" (click)="goTo(1)"></span> -->
                                    </div>
                                    <div class="contenu-div">
                                        <div class="row">
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 name">Raison sociale</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 value"> {{simulationRceForm.get('raisonSocial').value}} </div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 name">Adresse</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 value">{{simulationRceForm.get('adresse').value}} </div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 name">Forme juridique</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 value">{{simulationRceForm.get('formeJuridique').value}}</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 name">Activité entreprise</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 value">{{simulationRceForm.get('activiteEntreprise').value}} </div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 name">Date Exploitation</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 value">{{simulationRceForm.get('dateExploitation').value |date:'dd/MM/yyyy'}} </div>
                                            <!-- <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 name">Chiffre affaire</div> -->
                                            <!-- <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 value">{{simulationRceForm.get('chiffreAffaire').value | number:'1.0-0':'fr' }} </div> -->
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 name">chiffre Affaire Previsionnel</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 value">{{simulationRceForm?.get('chiffreAffairePreci')?.value | number:'1.0-0':'fr' }} </div>
                                            <!-- <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 name">Masse Salarial</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 value">{{simulationRceForm?.get('masseSalarial')?.value}}</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 name">Masse salarial Prévisionnel</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 value">{{simulationRceForm?.get('masseSalarialPreci')?.value}}</div> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6">
                                    <div class="title-div">
                                        <span>Information Entreprise</span>
                                        <!-- <span class="fa fa-edit edit-pro" placement="top" ngbPopover="Cliquer pour modifier les infos de l'assuré" triggers="mouseenter:mouseleave" (click)="goTo(3)"></span> -->
                                    </div>
                                    <div class="contenu-div">
                                        <div class="row">
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 name">Masse Salarial</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 value">{{simulationRceForm?.get('masseSalarial')?.value}}</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 name">Masse salarial Prévisionnel</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 value">{{simulationRceForm?.get('masseSalarialPreci')?.value}}</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 name">Nombre de Personnel</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 value">{{simulationRceForm?.get('nbrPersonnel')?.value}}</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 name">Principaux clients</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 value">{{simulationRceForm?.get('clientList')?.value}}</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 name">Chargement/déchargement</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 value">{{simulationRceForm.get('entreprise2').get('travaux').value}}</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 name">Locaux</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 value">{{simulationRceForm.get('entreprise2').get('locataireOrProprietaire').value}}</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 name">Matière dangereuse</div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 value">{{simulationRceForm.get('entreprise2').get('entrepose').value}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="disposition row">
                                <div class="title-dispo-footerL">
                                    <!-- Assureur : {{currentAssureur?.nom}} -->
                                </div>
                                <div class="title-dispo-footerR">
                                    Date emission : {{newDate |date:'dd/MM/yyyy HH:mm:ss' }} E-MAIL : {{constantes.EMAIL}}
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-5 c-btnWidth">
                            <button type="button" class="btn btn-warning btn-prev c-btn-prev pull-right c-roundbtn" (click)="retour()" awPreviousStep><i
                        class="fa fa-chevron-left"></i> Retour</button>
                        </div>
                        <div class="col-5 c-btnWidth">
                            <button type="button" class="btn btn-success btn-next pull-left c-roundbtn" [swal]="confirmSubscription2" [disabled]="sendingRequest"> <i class="fa fa-spinner fa-pulse"
                        *ngIf="sendingRequest"></i>Terminer</button>
                        </div>
                    </div>
                </aw-wizard-step>
            </aw-wizard>
        </form>
    </div>
</div>



<section class="find-agent-area-voyage ptb-100">
    <div class="container">
        <div class="section-title">
            <h2 class="avantage">Avantages</h2>
        </div>

        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="find-agent-content">
                    <div class="row">
                        <div class="col-lg-12 col-md-6 col-sm-6">
                            <div class="box">
                                <div class="icon">
                                    <i class="flaticon-briefcase"></i>
                                </div>

                                <h3 class="titre_card">Assistance rapatriement</h3>
                                <p>très utile si vous ne pouvez pas être traité sur place. La compagnie d’assurance organise votre rapatriement vers votre pays d’origine.</p>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-6 col-sm-6">
                            <div class="box">
                                <div class="icon">
                                    <i class="flaticon-briefcase"></i>
                                </div>

                                <h3 class="titre_card">Assurance en cas d’annulation du voyage </h3>
                                <p>Cette garantie vous permettra de ne pas perdre l’argent que vous auriez investi dans l’organisation de votre voyage.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="find-agent-content">
                    <div class="row">
                        <div class="col-lg-12 col-md-6 col-sm-6">
                            <div class="box">
                                <div class="icon">
                                    <i class="flaticon-briefcase"></i>
                                </div>

                                <h3 class="titre_card">Remboursement de frais</h3>
                                <p>Remboursement de frais médicaux en cas d’accident ou de maladie qui ne requiert pas d’une hospitalisation.</p>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-6 col-sm-6">
                            <div class="box">
                                <div class="icon">
                                    <i class="flaticon-briefcase"></i>
                                </div>

                                <h3 class="titre_card">Assurance bagages</h3>
                                <p>comme son nom l’indique, cette garantie vous permettra de ne pas perdre vos bagages en cas de vol de ceux-ci.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Modal pour la page login -->
<ng-template #contentResultlogin let-modal>
    <div class="login">
        <form [formGroup]="loginform">
            <div class="container px-4 py-5 mx-auto">
                <div class="card">
                    <a class="close text-primary text-right loginclose" aria-label="Close" (click)="modal.dismiss('close')">
                        <span aria-hidden="true">&times;</span>
                    </a>
                    <div class="d-flex flex-lg-row flex-column-reverse">
                        <div class="card card1">
                            <div class="row justify-content-center my-auto">
                                <div class="col-md-10 col-10 mt-5">
                                    <div class="row justify-content-center px-3 mb-3">
                                        <h3 class="monCompte"> Mon compte!</h3>
                                        <p class="compteText"> Connectez vous à votre compte SVP.</p>
                                    </div>
                                    <div class="form" ngbPopover="Nom d'utilisateur" triggers="mouseenter:mouseleave">
                                        <i class="fa fa-user form__icon"></i>
                                        <div class="form__separator">
                                        </div>
                                        <input type="text" id="nomUser" class="form__input" autocomplete="off" placeholder=" " formControlName="username" />
                                        <label for="nomUser" class="form__label">Nom d'utilisateur<span class="text-red"></span></label>
                                    </div>
                                    <div class="text-red" *ngIf="loginform.get('username')?.errors?.required">
                                        Le nom d'utilisateur est requis
                                    </div>
                                    <div class="form" ngbPopover="Mot de passe" triggers="mouseenter:mouseleave">
                                        <i class="fas fa-lock form__icon"></i>
                                        <div class="form__separator">
                                        </div>
                                        <input [type]="pwd" id="psw" class="form__input" autocomplete="off" placeholder=" " formControlName="password" />
                                        <label for="psw" class="form__label">Mot de passe<span class="text-red"></span></label>
                                        <i class="fas fa-eye form__icon-psw" *ngIf="pwd === 'password'" (click)="pwd = 'text'"></i>
                                        <i class="fas fa-eye-slash form__icon-psw" *ngIf="pwd === 'text'" (click)="pwd = 'password'"></i>
                                    </div>
                                    <div class="text-red" *ngIf="loginform.get('password')?.errors?.required && (loginform.get('password')?.touched || loginform.get('password')?.dirty)">
                                        Le mot de passe est requis
                                    </div>
                                    <div class="forgetMdp">
                                        <div class="resterConnecter">
                                            <input type="checkbox">
                                            <span> Restez connecter</span>
                                        </div>
                                        <div class="updateMdp">Mot de passe oublié?</div>
                                    </div>
                                    <div class="text-danger text-center mt-1" *ngIf="userInconnu!=''"> {{userInconnu}}</div>
                                    <div class="text-center"> <button class="seConnecter" (click)="connecter()" [disabled]="loaderVisible">Connectez-vous</button> </div>
                                    <div class="row justify-content-center my-3 px-3" *ngIf="loaderVisible">
                                        <p class="text-center w-100"><i class=" fa fa-spinner fa-pulse text-primary"></i></p>
                                        <p class="text-center ">
                                            Connexion en cours
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="bottom text-center mb-3 margeTop">
                                <p href="#" class="sm-text mx-auto mb-3">Vous n'avez pas de compte?<button class="btn btn-white ml-2" (click)="inscrire()" [disabled]="loaderVisible">Créez-en un!</button></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #contentResult let-modal>
    <div class="modal-body border border-none">
        <div class="cotainer devis-container bg-white" id="htmlData">
            <div class="row row-devis">
                <div class="col-12">
                    <div class="row row-title-devis align-items-center">
                        <div class="col-6 img-logo">
                            <img src="../../../../assets/images/logo6.png" alt="">
                        </div>
                        <div class="col-6 ">
                            <div class="row Informations">
                                <div class="col-12">
                                    <p>Tel: {{constantes.TEL}}</p>
                                </div>
                                <div class="col-12">
                                    <p>Email: info@optima.com</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row row-subtitle-devis ">
                        <div class="col-3 justify-content-center bg-primary">
                            <p class="devis-text">Devis</p>
                        </div>
                        <div class="col-9">
                            <div>
                                <div class="row assure">
                                    <div class="col-12 assure-title">
                                        Voyage
                                    </div>
                                    <div class="col-12 assure-text" *ngFor="let res of resultSimulation">
                                        <div class="row align-items-center" *ngIf="res?.key != 'Prime Totale TTC'">
                                            <div class="col-8">
                                                <p>{{res?.key}}</p>
                                            </div>
                                            <div class="col-4">{{res?.value | number :'1.0-0' : 'fr' }} FCFA</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngFor="let res of resultSimulation">
                                <div class="row assure" *ngIf="res?.key == 'Prime Totale TTC'">
                                    <div class="col-12 assure-title">
                                        Total
                                    </div>
                                    <div class="col-12 assure-text">
                                        <div class="row align-items-center ">
                                            <div class="col-8">
                                                <p>{{res?.key}}</p>
                                            </div>
                                            <div class="col-4">{{res?.value | number :'1.0-0' : 'fr' }} FCFA</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="modal.close('close')">Fermer</button>
        <button type="button" class="btn btn-success" (click)="modal.close('subscribe')">Souscrire</button>
    </div>

</ng-template>
<ng-template #contentResultgrise let-modal>
    <div class="modal-body">
        <div class="cotainer p-2" id="htmlData">
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="modal.close('close')">Fermer</button>
        <button type="button" class="btn btn-success" (click)="modal.close('subscribe')">Souscrire</button>
    </div>
</ng-template>
<ng-template #contentResult2 let-modal>
    <div class="modal-body">
        <div class="card mb-3 c-card-body">
            <div class="row g-0">
                <div class="col-md-12 p-4">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="row  align-items-center">
                                    <h5 class="text-center col-12 mb-5">Carte grise</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <button class="btn btn-danger  m-auto c-btn-close" (click)="modal.close('close')">Revenir</button>
    <button class="btn btn-success m-auto c-btn-close" (click)="modal.close('subscribe')">Continuer</button>
</ng-template>
<ng-template #contentResultcontact let-modal>
    <div class="c-modal-header" id="modal-header DKG">
        <h5 class="modal-title text-white" id="modal-basic-title" id="modal-title">Se faire contacter</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body bg-white" id="modal-body">
        <form [formGroup]="personcontactForm">
            <div class="form-container">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                        <div class="form" ngbPopover="Prénom" triggers="mouseenter:mouseleave">
                            <i class="fa fa-user-circle-o form__icon"></i>
                            <div class="form__separator">
                            </div>
                            <input type="text" id="email" class="form__input" autocomplete="off" placeholder=" " formControlName="first_name" />
                            <label for="email" class="form__label">Prénom<span class="text-red"> *</span></label>
                        </div>
                        <div class="error min-max text-red" *ngIf="personcontactForm?.get('first_name')?.hasError?.required">
                            Ce champ est obligatoire
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                        <div class="form" ngbPopover="Nom" triggers="mouseenter:mouseleave">
                            <i class="fa fa-user-circle-o form__icon"></i>
                            <div class="form__separator">
                            </div>
                            <input type="text" id="email" class="form__input" autocomplete="off" placeholder=" " formControlName="last_name" />
                            <label for="email" class="form__label">Nom<span class="text-red"> *</span></label>
                        </div>
                        <div class="error min-max text-red" *ngIf="personcontactForm?.get('last_name')?.hasError?.required">
                            Ce champ est obligatoire
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                        <div class="form" ngbPopover="Téléphone" triggers="mouseenter:mouseleave">
                            <i class="fa fa-phone form__icon"></i>
                            <div class="form__separator">
                            </div>
                            <input type="text" id="email" class="form__input" autocomplete="off" placeholder=" " prefix="+225 " [mask]="phoneMask" formControlName="telephone" />
                            <label for="email" class="form__label">Téléphone<span class="text-red"> *</span></label>
                        </div>
                        <div class="error min-max text-red" *ngIf="personcontactForm?.get('telephone')?.hasError?.required">
                            Ce champ est obligatoire
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                        <div class="form" ngbPopover="Email" triggers="mouseenter:mouseleave">
                            <i class="fa fa-envelope form__icon"></i>
                            <div class="form__separator">
                            </div>
                            <input type="text" id="email" class="form__input" autocomplete="off" placeholder=" " formControlName="email" />
                            <label for="email" class="form__label">Email<span class="text-red"> *</span></label>
                        </div>
                        <div class="error min-max text-red" *ngIf="personcontactForm.get('email').hasError('pattern')">
                            Ce champ est invalide
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                        <div class="form-group">
                            <div class="input-group" placement="top" ngbPopover="Jour disponible" triggers="mouseenter:mouseleave">
                                <div class="input-group-append">
                                    <i class="fa fa-calendar text-white"> <span class="text-red">*</span></i>
                                </div>
                                <ng-select multiple="true" class="select-rappel" placeholder="Jour à être rappeler" formControlName="jour" clearAllText="Effacer tout" notFoundText="Aucun élément trouvé" [dropdownPosition]="'bottom'">
                                    <ng-option *ngFor="let jour of listJours" [value]="jour.name"> {{jour.name}} </ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <div class="error min-max text-red" *ngIf="personcontactForm?.get('jour')?.hasError?.required">
                            Ce champ est obligatoire
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                        <div class="form-group">
                            <div class="input-group" placement="top" ngbPopover="Heure disponible" triggers="mouseenter:mouseleave">
                                <div class="input-group-append">
                                    <i class="fa fa-calendar text-white"> <span class="text-red">*</span></i>
                                </div>
                                <ng-select multiple="true" class="select-rappel" placeholder="Heure à être rappeler" formControlName="heure" clearAllText="Effacer tout" notFoundText="Aucun élément trouvé" [dropdownPosition]="'bottom'">
                                    <ng-option *ngFor="let heure of listHeures" [value]="heure.name"> {{heure.name}} </ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <div class="error min-max text-red" *ngIf="personcontactForm?.get('heure')?.hasError?.required">
                            Ce champ est obligatoire
                        </div>
                    </div>
                </div>
            </div>
            <button type="button" class="btn btn-danger" #closeBTN (click)="modal.close('close')">Fermer</button>
            <button type="button" class="btn btn-success" [disabled]="loadContact" (click)="saveContact()"> <span
            *ngIf="loadContact" class="fa fa-spinner fa-pulse"></span> Envoyer</button>
        </form>
    </div>
</ng-template>
<ng-template #contentResultass let-modal>
    <div class="modal-body p-5 bg-white  autodown" #autoDownload id="autoDownload">
        <div class="mesImage row col-md-12 col-lg-12 col-sm-12 col-xs-12">
            <div class="imgLogo col-md-6 col-lg-6 col-sm-12 col-xs-12">
                <!-- <img src="../../../../assets/img/logo123.png" alt=""> -->
                <img [src]="logoImage" alt="logo">
            </div>
            <div class="imgLogoR col-md-6 col-lg-6 col-sm-12 col-xs-12">
                <!-- <img src="../../../../assets/img/logo.png" alt=""> -->
            </div>
        </div>
        <div class="info-devis">
            <div class="proposition">
                <div class="pro-title"> Proposition Voyage</div>
                <div class="sub-title">(Cette proposition est valable jusqu'au {{dateExpiration | date:'dd/MM/yyyy'}})
                </div>
            </div>
            <div class="row ">
                <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6">
                    <div class="title-div">
                        Références du souscripteur
                    </div>
                    <div class="contenu-div">
                        <div class="row">
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Numéro</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value"> {{numeroSous}} </div>
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Nom</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                {{user?.infos?.firstName}} {{user?.infos?.lastName}} </div>
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Email</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                {{user?.infos?.email}} </div>
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Téléphone</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                {{user?.infos?.telephone}} </div>
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Adresse</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                {{user?.infos?.adresse}} </div>
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Profession</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                {{user?.infos?.profession}} </div>
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Activité</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                {{user?.infos?.secteuractivite}} </div>
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Intermédiare</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value"> {{currentAssureur?.nom}} </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6">
                    <div class="title-div">
                        <span>Références Proposition</span>
                    </div>
                    <div class="contenu-div">
                        <div class="row">

                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Numéro</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value"> {{refPro}} </div>

                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Emission</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value"> {{newDate |date:'dd/MM/yyyy HH:mm:ss'}}
                            </div>
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Assuré(e)</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                {{user?.infos?.firstName}} {{user.infos.lastName}} </div>
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Adresse</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                {{user?.infos?.adresse}} </div>
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Date d'effet</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                {{simulationRceForm.get('dateDepart').value | date:'dd/MM/yyyy HH:mm:ss'}} </div>

                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Date d'expiration</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value"> {{simulationRceForm.get('dateRetour').value | date:'dd/MM/yyyy'}}
                            </div>

                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Durée</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value"> 1 an </div>
                            <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 name c-mt"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row ">
                <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 c-col-12">
                    <div class="title-div">
                        <span> Identification du voyage </span>
                    </div>
                    <div class="contenu-div">
                        <div class="row">
                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 ">
                                <div class="row">
                                    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 name">Pays de départ</div>
                                    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 value">
                                        Sénégal
                                    </div>
                                    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 name">Date de départ</div>
                                    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 value">
                                        {{simulationRceForm.get('dateDepart').value | date:'dd/MM/yyyy':'fr'}} </div>
                                    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 name">Age</div>
                                    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 value">
                                        {{age}} an(s)</div>

                                </div>
                            </div>

                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 ">
                                <div class="row">
                                    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 name">Pays d'arrivée</div>
                                    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 value">
                                        {{getNamePaysById(simulationRceForm.get('paysArrive').value)}} </div>
                                    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 name">Date de retour</div>
                                    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 value">
                                        {{simulationRceForm.get('dateRetour').value | date:'dd/MM/yyyy':'fr'}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="proposition2">
                <div class="pro-title"> Garanties Souscrites et Primes d’assurance (en FCFA)</div>
            </div>
            <div class="row c-row">
                <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6">
                    <div class="title-div">
                        <span> Nature des garanties </span>
                    </div>
                    <div class="contenu-div">
                        <div class="row">
                            <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                Frais médicaux et hospitalisation
                            </div>
                            <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                Assistance et rapatriement
                            </div>
                            <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                Responsabilité civile à l’étranger
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6">
                    <div class="title-div">
                        Primes d’assurance
                    </div>
                    <div class="contenu-div">
                        <div class="row">
                            <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 val">
                                Gratuit
                            </div>
                            <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 val">
                                Gratuit
                            </div>
                            <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 val">
                                Gratuit
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="description-ass">
                Par conséquant, le souscripteur s'engage à payer au comptant à la signature du présent contrat la somme de <b>
            {{tot | number:'1.0-0':'fr'}} FCFA</b> décomptée comme suit:
            </div>
            <div class="row ">
                <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 c-col-122">

                    <div class="contenu-div">
                        <div class="row">
                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-prime">
                                <div *ngFor="let item of resultSimulation">
                                    <span *ngIf="item.key!='Montant TTC'">{{item.key}}</span>
                                    <span *ngIf="item.key=='Montant TTC'" class="valPrime">{{item.key}}</span>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                                <div class="val" *ngFor="let item of resultSimulation">
                                    <span *ngIf="item.key!='Montant TTC'">{{item.value | number:'1.0-0':'fr'}} FCFA</span>
                                    <span *ngIf="item.key=='Montant TTC'" class="valPrime">{{item.value |
                      number:'1.0-0':'fr'}} FCFA</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="disposition">
          <div class="title-disp">
            Dispositions complémentaires
          </div>
          <div class="desc-disp">
            La prise d'effet du contrat est subordonnée au paiement préalable de la prime conformémet au
            disposition de
            l'article 13
            <div class="">-&nbsp; Le présent contrat est résu par le code des assurances CIMA, les conditions
              générales
              jointes, les conditions particulières ainsi que les closes en annexe.</div>
            <div class="">-&nbsp; Il est précisé que les conditions particulières (CP) annulent et remplace toute
              disposition des conditions générales (CG) qui leurs sont contraires.</div>
            <div class="">-&nbsp; Sont nulles toutes adjonctions ou modifications matérièlles non revétues des
              visas de
              l'assureur et du souscripteur. </div>
          </div>
        </div> -->
            <div class="disposition row">
                <div class="title-dispo-footerL">
                    Assureur : {{currentAssureur?.nom}}
                </div>
                <div class="title-dispo-footerR">
                    Date emission : {{newDate |date:'dd/MM/yyyy HH:mm:ss' }} E-MAIL : info@optima.com
                </div>
            </div>

        </div>
        <!-- <div class="footer-devis row">
        <div class="col-md-10 col-lg-10 col-sm-12 col-xs-12">
          <div class="fist-line">
            <b class="name-devis">{{currentAssureur?.nom}}</b> est une <b>{{currentAssureur?.typeSociete}}</b> avec
            conseil
            d'administration au capital de <b>{{convertStringToNumber(currentAssureur?.capital) |
              number:"1.0-0":'fr'}}</b>. Elle a été créée en <b>{{currentAssureur?.anneeCreation}}</b>. NINEA
            <b>{{currentAssureur.ninea}}</b>-RC: <b>{{currentAssureur?.registreCommerce}}</b> Elle est régie par le
            code
            des assurances CIMA. Son siège est situé à <b>{{currentAssureur?.adresse}}</b>.
          </div>
          <div class="second-line">Tel:&nbsp; <b>{{currentAssureur?.telephone}}</b> &nbsp;&nbsp;Email:
            &nbsp;<b>{{currentAssureur?.email}}</b> </div>
        </div>
        <div class="col-md-2 col-lg-2 col-sm-12 col-xs-12">
          <img class="footer-img" [src]="currentAssureur?.img" alt="">
        </div>
      </div> -->
    </div>
    <div *ngIf="isSouscription">
        <button type="button" class="btn btn-warning btn-prev c-btn-prev pull-left" (click)="modal.close('close')"><i
          class="fa fa-chevron-left"></i> Retour</button>
        <button type="button" class="btn btn-primary c-roundbtn btn-tel pull-left" (click)="openPDF()">Télécharger <i
          class="fa fa-download"></i></button>
        <button type="button" class="btn btn-success btn-next c-roundbtn pull-right" (click)="modal.close('subscribe')">
        Souscrire <i class="fa fa-angle-double-right"></i>
      </button>
    </div>
    <div *ngIf="!isSouscription" class="btnSous">

        <button type="button" class="btn btn-primary btn-tel pull-left" (click)="openPDF()"><i
          class="fa fa-download"></i></button>

    </div>
</ng-template>
<ng-template #contentResultlogin let-modal>
    <div class="modal-body login">
        <form [formGroup]="loginform">
            <div class="container px-4 py-5 mx-auto">
                <div class="card">
                    <a class="close text-primary text-right loginclose" aria-label="Close" (click)="modal.dismiss('close')">
                        <span aria-hidden="true">&times;</span>
                    </a>
                    <div class="d-flex flex-lg-row flex-column-reverse">
                        <div class="card card1">
                            <div class="row justify-content-center my-auto">
                                <div class="col-md-10 col-10 mt-5">
                                    <div class="row justify-content-center px-3 mb-3">
                                        <h3 class="monCompte"> Mon compte!</h3>
                                        <p class="compteText"> Connectez vous à votre compte SVP.</p>
                                    </div>
                                    <div class="form" ngbPopover="Nom d'utilisateur" triggers="mouseenter:mouseleave">
                                        <i class="fa fa-user form__icon"></i>
                                        <div class="form__separator">
                                        </div>
                                        <input type="text" id="email" class="form__input" autocomplete="off" placeholder=" " formControlName="username" />
                                        <label for="email" class="form__label">Nom d'utilisateur<span class="text-red"></span></label>
                                    </div>
                                    <div class="text-red" *ngIf="loginform.get('username')?.errors?.required">
                                        Le nom d'utilisateur est requis
                                    </div>

                                    <div class="form" ngbPopover="Mot de passe" triggers="mouseenter:mouseleave">
                                        <i class="fas fa-lock form__icon"></i>
                                        <div class="form__separator">
                                        </div>
                                        <input [type]="pwd" id="psw" class="form__input" autocomplete="off" placeholder=" " formControlName="password" />
                                        <label for="psw" class="form__label">Mot de passe<span class="text-red"></span></label>
                                        <i class="fas fa-eye form__icon-psw" *ngIf="pwd === 'password'" (click)="pwd = 'text'"></i>
                                        <i class="fas fa-eye-slash form__icon-psw" *ngIf="pwd === 'text'" (click)="pwd = 'password'"></i>
                                    </div>
                                    <div class="text-red" *ngIf="loginform.get('password')?.errors?.required && (loginform.get('password')?.touched || loginform.get('password')?.dirty)">
                                        Le mot de passe est requis
                                    </div>
                                    <div class="forgetMdp">
                                        <div class="resterConnecter">
                                            <input type="checkbox">
                                            <span> Restez connecter</span>
                                        </div>
                                        <div class="updateMdp">Mot de passe oublié?</div>
                                    </div>
                                    <div class="text-danger text-center mt-1" *ngIf="userInconnu!=''"> {{userInconnu}}</div>
                                    <div> <button class="seConnecter" (click)="connecter()" [disabled]="loaderVisible">Connectez-vous</button> </div>
                                    <div class="row justify-content-center my-3 px-3" *ngIf="loaderVisible">
                                        <p class="text-center w-100"><i class=" fa fa-spinner fa-pulse text-primary"></i></p>
                                        <p class="text-center ">
                                            Connexion en cours
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="bottom text-center mb-3">
                                <p href="#" class="sm-text mx-auto mb-3">Vous n'avez pas de compte?<button class="btn btn-white ml-2" (click)="inscrire()" [disabled]="loaderVisible">Créez-en un!</button></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

    </div>

</ng-template>
<!--start inscription -->
<!-- <ng-template #contentResultsign let-modal>
    <div class="modal-body login">
        <form [formGroup]="inscriptionForm">
            <div class="container px-4 py-2 mx-auto">
                <div class="card">
                    <a class="close text-primary text-right loginclose" aria-label="Close" (click)="modal.dismiss('close')">
                        <span aria-hidden="true">&times;</span>
                    </a>
                    <div class="d-flex flex-lg-row flex-column-reverse">
                        <div class="card card1">
                            <div class="row justify-content-center my-auto">
                                <div class="col-md-10 col-10 mt-2">
                                    <div class="row justify-content-center px-3 mb-3"> <img id="logo" src="../../../../../assets/images/logo.png"> </div>
                                    <h6 class="msg-info text-center">Veuillez remplire ces champs svp!</h6>
                                    <div class="form-group"> <label class="form-control-label text-muted">Adresse mail</label> <input type="email" id="email" name="email" placeholder="" class="form-control" formControlName="email">
                                        <div class="text-red ml-3" *ngIf="inscriptionForm.get('email')?.errors?.required && (inscriptionForm.get('email')?.touched || inscriptionForm.get('email')?.dirty)">
                                            Le champs email est requis</div>
                                        <div class="text-red ml-3" *ngIf="inscriptionForm.get('email')?.errors?.pattern">Le champs email est incorrect
                                        </div>
                                    </div>
                                    <div class="form-group"> <label class="form-control-label text-muted">Numéro téléphone <span
                          class="text-red">*</span></label> <input type="text" id="tel" placeholder="" class="form-control" formControlName="tel" prefix="+225 " [mask]="phoneMask">
                                        <div class="text-red ml-3" *ngIf="inscriptionForm.get('tel')?.errors?.required && (inscriptionForm.get('tel')?.touched || inscriptionForm.get('tel')?.dirty)">
                                            Le champs téléphone est requis</div>
                                    </div>
                                    <div class="row justify-content-center my-3 px-3"> <button class="btn-block btn-color" (click)="inscrireutil()" [disabled]="loaderVisible">S'inscrire</button> </div>
                                    <div class="row justify-content-center my-3 px-3" *ngIf="loaderVisible">
                                        <p class="text-center w-100"><i class=" fa fa-spinner fa-pulse text-primary"></i></p>
                                        <p class="text-center ">
                                            Inscription en cours
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="bottom text-center mb-1">
                                <p href="#" class="sm-text mx-auto mb-3">Vous avez déjà un compte?<button class="btn btn-white ml-2" (click)="souscrire()" [disabled]="loaderVisible">Connectez-vous!</button></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

    </div>
</ng-template> -->
<ng-template #contentResultsign let-modal>
    <div class="modal-body login">
        <form [formGroup]="inscriptionForm">
            <div class="container px-4 py-2 mx-auto">
                <div class="card card0">
                    <a class="close text-primary text-right loginclose" aria-label="Close" (click)="modal.dismiss('close')">
                        <span aria-hidden="true">&times;</span>
                    </a>
                    <div class="d-flex flex-lg-row flex-column-reverse">
                        <div class="card card1">
                            <div class="row justify-content-center my-auto">
                                <div class="col-md-10 col-10 mt-2">
                                    <!-- <div class="row justify-content-center px-3 mb-3"> <img id="logo" src="../../../../../assets/img/logo.png"> </div> -->
                                    <h6 class="msg-info text-center">Veuillez remplir ces champs svp!</h6>
                                    <div class="form-group"> <label class="form-control-label text-muted">Nom</label>
                                        <input type="text" id="nom" placeholder="" class="form-control" formControlName="nom">
                                        <div class="text-red ml-3" *ngIf="inscriptionForm.get('nom')?.errors?.required">
                                            Le champs nom est requis</div>
                                    </div>
                                    <div class="form-group"> <label class="form-control-label text-muted">Prénom
                                        </label> <input type="text" id="prenom" placeholder="" class="form-control" formControlName="prenom">
                                        <div class="text-red ml-3" *ngIf="inscriptionForm.get('prenom')?.errors?.required && (inscriptionForm.get('prenom')?.touched || inscriptionForm.get('prenom')?.dirty)">
                                            Le champs prénom est requis</div>
                                    </div>
                                    <div class="form-group"> <label class="form-control-label text-muted">Adresse
                                            mail</label> <input type="email" id="email" name="email" placeholder="" class="form-control" formControlName="email">
                                        <div class="text-red ml-3" *ngIf="inscriptionForm.get('email')?.errors?.required && (inscriptionForm.get('email')?.touched || inscriptionForm.get('email')?.dirty)">
                                            Le champs email est requis</div>
                                        <div class="text-red ml-3" *ngIf="inscriptionForm.get('email')?.errors?.pattern">Le champs email est incorrect
                                        </div>
                                    </div>
                                    <div class="form-group"> <label class="form-control-label text-muted">Numéro
                                            téléphone</label> <input type="text" id="telephone" placeholder="" class="form-control" formControlName="telephone" prefix="+225 " [mask]="phoneMask">
                                        <div class="text-red ml-3" *ngIf="inscriptionForm.get('telephone')?.errors?.required && (inscriptionForm.get('telephone')?.touched || inscriptionForm.get('telephone')?.dirty)">
                                            Le champs téléphone est requis</div>
                                    </div>
                                    <div class="row justify-content-center my-3 px-3"> <button class="seConnecter" (click)="inscrireutil()" [disabled]="loaderVisible">S'inscrire</button> </div>
                                    <div class="row justify-content-center my-3 px-3" *ngIf="loaderVisible">
                                        <p class="text-center w-100"><i class=" fa fa-spinner fa-pulse text-primary"></i></p>
                                        <p class="text-center ">
                                            Inscription en cours
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="bottom text-center mb-1">
                                <p href="#" class="sm-text mx-auto mb-3">Vous avez déjà un compte?<button class="btn btn-white ml-2" (click)="souscrire()" [disabled]="loaderVisible">Connectez-vous!</button></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-template>
<!-- end inscription -->

<ng-template #contentResultforgot let-modal>
    <div class="modal-body login">
        <form [formGroup]="forgotForm">
            <div class="container px-4 py-2 mx-auto">
                <div class="card">
                    <a class="close text-primary text-right loginclose" aria-label="Close" (click)="modal.dismiss('close')">
                        <span aria-hidden="true">&times;</span>
                    </a>
                    <div class="d-flex flex-lg-row flex-column-reverse">
                        <div class="card card1">
                            <div class="row justify-content-center my-auto">
                                <div class="col-md-10 col-10 mt-5">
                                    <div class="row justify-content-center px-3 mb-3"> <img id="logo" [src]="logoImage"> </div>
                                    <div class="form-group"> <label class="form-control-label text-muted">Adresse mail</label> <input type="text" id="email" name="email" placeholder="" class="form-control" formControlName="email">
                                    </div>
                                    <div class="row justify-content-center my-3 px-3"> <button class="btn-block btn-color" (click)="forgot()" [disabled]="loaderVisible">Réinitialiser compte</button> </div>
                                    <div class="row justify-content-center my-3 px-3" *ngIf="loaderVisible">
                                        <p class="text-center w-100"><i class=" fa fa-spinner fa-pulse text-primary"></i></p>
                                        <p class="text-center ">
                                            Réinitialisation en cours
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-template>

<!--start me rappeler -->
<ng-template #etreRappeller let-modal>
    <form [formGroup]="rappellerForm">
        <!-- <div class="container px-2 py-1 mx-auto"> -->
        <div class="card card2 c-card">
            <!-- <div class="row beneficiary-section form-container "> -->
            <div class="row no-margin">
                <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 c-headModal">
                    <div class="row no-margin">
                        <div class="col-10 p-0">
                            <h6 class="text-left text-white c-cardTitle">Me faire rappeler</h6>
                        </div>
                        <div class="col-lg-2 text-right1">
                            <a aria-label="Close" (click)="modal.dismiss('close')" class="text-right"><i
                      class="fa fa-times text-white times-ass c-times-ass"></i></a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 mt-3">
                    <div class="row">

                        <div class="col-lg-6 col-md-12 col-xs-12 col-sm-12">
                            <div class="form" ngbPopover="Nom" triggers="mouseenter:mouseleave">
                                <i class="fa fa-user form__icon"></i>
                                <div class="form__separator">
                                </div>
                                <input type="text" id="emai" class="form__input" autocomplete="off" placeholder=" " formControlName="nom" />
                                <label for="emai" class="form__label">Nom<span
                                        class="text-red"> *</span></label>
                            </div>
                            <div class="error  text-red" *ngIf="invalid && rappellerForm.get('nom').invalid">
                                Ce champ est obligatoire
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12 col-xs-12 col-sm-12">
                            <div class="form" ngbPopover="Prénom" triggers="mouseenter:mouseleave">
                                <i class="fa fa-user form__icon"></i>
                                <div class="form__separator">
                                </div>
                                <input type="text" id="prenom" class="form__input" autocomplete="off" placeholder=" " formControlName="prenom" />
                                <label for="prenom" class="form__label">Prénom<span
                                        class="text-red"> *</span></label>
                            </div>
                            <div class="error  text-red" *ngIf="invalid && rappellerForm.get('prenom').invalid">
                                Ce champ est obligatoire
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12 col-xs-12 col-sm-12">
                            <div class="form" ngbPopover="Email" triggers="mouseenter:mouseleave">
                                <i class="fa fa-envelope form__icon"></i>
                                <div class="form__separator">
                                </div>
                                <input type="text" id="emai" class="form__input" autocomplete="off" placeholder=" " formControlName="email" />
                                <label for="emai" class="form__label">Email<span
                                        class="text-red"> *</span></label>
                            </div>
                            <div class="error  text-red" *ngIf="invalid && rappellerForm.get('email').invalid">
                                Ce champ est obligatoire
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12 col-xs-12 col-sm-12">
                            <div class="form" ngbPopover="Téléphone" triggers="mouseenter:mouseleave">
                                <i class="fa fa-phone form__icon"></i>
                                <div class="form__separator">
                                </div>
                                <input type="text" id="telephone" class="form__input" autocomplete="off" placeholder="Téléphone" formControlName="telephone" />
                                <label for="telephone" class="form__label">Téléphone<span
                                        class="text-red"> *</span></label>
                            </div>
                            <div class="error  text-red" *ngIf="invalid && rappellerForm.get('telephone').invalid">
                                Ce champ est obligatoire
                            </div>
                        </div>


                        <div class="col-lg-6 col-md-12 col-xs-12 col-sm-12">
                            <div class="form" placement="top" ngbPopover="Disponibilité" triggers="mouseenter:mouseleave">
                                <i class="fa fa-car form__icon"></i>
                                <div class="form__separator">
                                </div>
                                <select id="cars" placeholder=" " class="form__select" name="disponibilite" formControlName="disponibilite" name="product" #disponibilite (change)="checkDisponiblite()">
                                    <option value="" disabled selected>Disponibilité</option>
                                    <option *ngFor="let dispo of disponibiteList" [value]="dispo.value">{{dispo?.name}}
                                    </option>
                                </select>
                                <label for="cars" class="form__label">Disponibilité<span class="text-red">
                                        *</span></label>
                            </div>
                            <div class="error min-max text-red" *ngIf="invalid && rappellerForm.get('disponibilite').invalid">
                                Ce champ est obligatoire
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12 col-xs-12 col-sm-12" *ngIf="rappellerForm.get('disponibilite').value =='Soir' || rappellerForm.get('disponibilite').value =='Matin'">
                            <div class="form" placement="top" ngbPopover="Quelle heure" triggers="mouseenter:mouseleave">
                                <i class="fa fa-car form__icon"></i>
                                <div class="form__separator">
                                </div>
                                <select id="cars" placeholder=" " class="form__select" name="heureDisponibilite" formControlName="heureDisponibilite" #heureDisponibilite>
                                    <option value="" disabled selected>Quelle heure</option>
                                    <option *ngFor="let heure of heureDisponibiliteListTemoin" [value]="heure.value">{{heure?.name}}
                                    </option>
                                </select>
                                <label for="cars" class="form__label">Quelle heure<span class="text-red">
                                        *</span></label>
                            </div>
                            <div class="error min-max text-red" *ngIf="invalid && rappellerForm.get('heureDisponibilite').invalid">
                                Ce champ est obligatoire
                            </div>
                        </div>
                    </div>
                </div>


                <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 text-center">
                    <button class="btn btn-large c-btnAjout" (click)="meRappeller()" [disabled]="sendingRequestRappel">
                  <i class="fa fa-pencil" *ngIf="!sendingRequestRappel"></i>
                  <i class="fa fa-spinner fa-pulse" *ngIf="sendingRequestRappel"></i>
                  Valider
                </button>
                </div>
            </div>
        </div>
    </form>
</ng-template>

<!-- end me rappeler -->


<!-- Modal pour étre rappelé -->
<ng-template #devisAEnvoye let-modal>
    <form [formGroup]="etrerappeleForm">
        <!-- <div class="container px-2 py-1 mx-auto"> -->
        <div class="card card0 c-card">
            <!-- <div class="row beneficiary-section form-container "> -->
            <div class="row no-margin">
                <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 c-headModal">
                    <div class="row no-margin">
                        <div class="col-10 p-0">
                            <h6 class="text-left text-white c-cardTitle">{{assureurAEnvoye?.displayMe}}</h6>
                        </div>
                        <div class="col-lg-2 text-right">
                            <a aria-label="Close" (click)="modal.dismiss('close')" class="text-right"><i
                    class="fa fa-times text-white times-ass c-times-ass"></i></a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 mt-3">
                    <div class="row">

                        <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                            <div class="form" placement="top" ngbPopover="Date de rappel" triggers="mouseenter:mouseleave">
                                <i class="fa fa-calendar form__icon"></i>
                                <div class="form__separator">
                                </div>
                                <select id="date" placeholder="" class="form__select" name="date" formControlName="date" name="date" #vehicule>
                          <option value="" disabled selected>Jour de rappel</option>
                          <option *ngFor="let rapel of dateRappel" [value]="rapel.value">{{rapel?.name}}</option>
                        </select>
                                <label for="cars" class="form__label">Jour de rappel<span class="text-red"> *</span></label>
                            </div>
                            <div class="error min-max text-red" *ngIf="etrerappeleForm.get('date').invalid && updateRequest">
                                Ce champ est obligatoire
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                            <div class="form" placement="top" ngbPopover="Heure de rappel" triggers="mouseenter:mouseleave">
                                <i class="fa-regular fa-clock form__icon c-icon"></i>
                                <div class="form__separator">
                                </div>
                                <ngx-bootstrap-multiselect formControlName="heure" name="heure" class="form__select" [texts]="myTexts" [settings]="mySettings" #heure [options]="heureRappel"></ngx-bootstrap-multiselect>
                                <label for="cars" class="form__label">Heure de rappel<span class="text-red"> *</span></label>
                            </div>
                            <div class="error min-max text-red" *ngIf=" etrerappeleForm.get('heure').invalid && updateRequest">
                                Ce champ est obligatoire
                            </div>
                        </div>
                    </div>
                    <!-- <div class="noDataGaranties" *ngIf="garantie?.length == 0 ">
                Chargemet en cours ...
              </div> -->
                </div>
                <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 text-center">
                    <button class="btn btn-large c-btnAjout" (click)="etreRappele()" [disabled]="updateRequest">
                <i class="fa fa-pencil" *ngIf="!updateRequest"></i>
                <i class="fa fa-spinner fa-pulse" *ngIf="updateRequest"></i>
                Valider
              </button>
                </div>
            </div>
            <!-- </div> -->
        </div>
        <!-- </div> -->
    </form>
</ng-template>
<swal #confirmSubscription2 [reverseButtons]="true" title="Confirmation" text="Voulez-vous vraiment procéder à la souscription ?" icon="question" [showCancelButton]="true" [focusCancel]="false" [confirmButtonText]="'OUI,  BIEN SÛR'" [cancelButtonText]="'NON, ANNULER'"
    (confirm)="saveData()">
</swal>

<ng-template #mypop>
    1.Pour moi-même : mon nom est sur la carte à grise
    <br>2.Pour un tiers :pour une tierce personne
    <br>3.Pour le compte de :c'est ma voiture mais mon nom n'est pas sur la carte à grise
</ng-template>
